import React from 'react';
import { useTranslation } from 'react-i18next';
import { VehicleFeatureTag, PriceTag, CapacityBadge } from '../atoms';
import { Button } from '../atoms';

const VehicleCard = ({ 
  vehicle, 
  type = 'vip', // 'vip' or 'bus'
  className = "" 
}) => {
  const { t } = useTranslation();

  const renderVipCard = () => (
    <div className={`bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 ${className}`}>
      {/* Header */}
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              {vehicle.title}
            </h3>
            <CapacityBadge 
              capacity={vehicle.capacity} 
              label={t('serviceDetail.vipCar.vehicles.capacityLabel')}
            />
          </div>
          <div className="text-right">
            <div className="text-sm text-gray-500 mb-1">
              {t('serviceDetail.vipCar.vehicles.hourlyRateFrom')}
            </div>
            <div className="text-2xl font-bold text-orange-600">
              {vehicle.hourlyRate}
            </div>
            <div className="text-sm text-gray-600">
              {t('serviceDetail.vipCar.vehicles.hourlyRateUnit')}
            </div>
          </div>
        </div>
        
        <p className="text-gray-600 text-sm leading-relaxed">
          {vehicle.description}
        </p>
      </div>

      {/* Features */}
      <div className="p-6">
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-700 mb-3">
            {t('serviceDetail.vipCar.vehicles.featuresLabel')}
          </h4>
          <div className="flex flex-wrap gap-2">
            {vehicle.features.map((feature, index) => (
              <VehicleFeatureTag key={index}>
                {feature}
              </VehicleFeatureTag>
            ))}
          </div>
        </div>

        <Button 
          variant="outline" 
          className="w-full border-orange-200 text-orange-600 hover:bg-orange-50"
        >
          {t('serviceDetail.vipCar.vehicles.inquireDetails')}
        </Button>
      </div>
    </div>
  );

  const renderBusCard = () => (
    <div className={`bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-all duration-300 ${className}`}>
      {/* Header */}
      <div className="p-6 border-b border-gray-100">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              {vehicle.title}
            </h3>
            <CapacityBadge 
              capacity={vehicle.capacity} 
              label={t('common.capacity')}
            />
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-blue-600">
              {vehicle.price}
            </div>
          </div>
        </div>
        
        <p className="text-gray-600 text-sm leading-relaxed">
          {vehicle.description}
        </p>
      </div>

      {/* Features */}
      <div className="p-6">
        <div className="mb-4">
          <h4 className="text-sm font-semibold text-gray-700 mb-3">
            {t('common.features')}
          </h4>
          <div className="flex flex-wrap gap-2">
            {vehicle.features.map((feature, index) => (
              <VehicleFeatureTag key={index}>
                {feature}
              </VehicleFeatureTag>
            ))}
          </div>
        </div>

        <Button 
          variant="outline" 
          className="w-full border-blue-200 text-blue-600 hover:bg-blue-50"
        >
          {t('common.inquireDetails')}
        </Button>
      </div>
    </div>
  );

  return type === 'vip' ? renderVipCard() : renderBusCard();
};

export default VehicleCard;
